<template>
    <div class="filtersContainer"> 
        <div class="filtersWrapper"> 
                <div v-if="key!=='sellerId'" class="filter" > 
                    <div class="filterName" v-bind:class="showFilter ? 'active' : null" @click="onFilterClick">
                        <div style="display: flex"> 
                            <div>{{ filter.replace(/_/g, " ") }}</div>
                            <div v-if="!showFilter && count>0" style="margin-left: 5px" class="filterCount">({{ count }})</div>
                        </div>
                        <img v-bind:class="showFilter ? 'activeIcon' : null" class="icon" src="../assets/chevron_down.svg" alt="icon">
                    </div>
                    <div  v-if="showFilter" class="countContainer"> 
                        <div class="count">{{ count }} selected</div>
                        <div v-if="count !== value.length" class="count clear" @click="onSelectAll">Select all</div>
                        <div :style="`visibility: ${count > 0 ? '' : 'hidden'}`" class="count clear" @click="onClear">Clear all</div>
                    </div>
                    <div v-if="showFilter" class="filterWrapper"> 
                        <div v-for="(checkbox, index) in filterCheckboxes" :key="index" style="margin-bottom: 15px"> 
                            <div class="text"> 
                                <input name="date" type="checkbox" @change="onFilterChange(this.filter, checkbox.label, checkbox.checked)" class="checkbox"  v-bind:checked="checkbox.checked" :id="'filter-' + index" v-model="checkbox.checked">
                                <label class="label" for="date">{{ checkbox.label }}</label>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
import { toRaw } from 'vue';

export default{
    name: 'Filters',
    props: {
        filter: String,
        value: Array,
        prefillValue: String,
        count: Number
    },
    data(){
        return {
            showFilter: false,
            isChecked: false,
            checkedItems: [],
        }
    },

    computed: {
        filterCheckboxes() {
            return Object.values(this.value).map(key => {
                if(this.prefillValue?.includes(key)){
                    return {
                        label: key,
                        checked: true
                    }
                }else {
                    return {
                        label: key,
                        checked: false
                    }
                }
            });
        },
    },
    methods: {
        onClear(){
            this.$emit('onClear', this.filter)
        },
        onSelectAll() {
            this.$emit('onSelectAll', this.filter, this.value)
        },
        onFilterChange(filterName, value, checked){
                this.$emit('onFilterChange', {filterName, value, checked: checked })

            const item = { value, checked: checked };
            const index = this.checkedItems.findIndex((obj) => obj.value === value);
            if (index >= 0) {
                this.checkedItems.splice(index, 1, item);
            } else {
                this.checkedItems.push(item);
            }
        },
        onFilterClick(){
            this.showFilter = !this.showFilter
        }
    }
}
</script>


<style scoped>

@font-face {
    font-family: "Inter-Regular";
    src: url('../assets/fonts/Inter-Regular.ttf');
}
.active{
    background: #2E31BE !important;
    color: #FFFFFF !important;
    opacity: unset !important;

}


.filterWrapper{
    margin-top: 20px;
}
.filtersContainer{
   
    font-family: "Inter-Regular";
    margin-bottom: 18px;
}

.count{
    font-family: "Inter-Regular";
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    letter-spacing: 0em;
    text-align: left;
}

.clear{
    cursor: pointer;
}

.countContainer{
    display: flex;
    justify-content: space-between;
    padding-left: 10px;
    padding-right: 20px;
    padding-top: 5px;
}

.label{
    font-family: "Inter-Regular";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: #41434C;
    margin-left: 6px;
}

.text{
    margin-left: 48px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
}
.title{
    font-weight: 600;
    font-size: 16px;
    line-height: 23px;
    color: rgba(0, 0, 0, 0.65);
    opacity: 0.8;
    /* margin-bottom: 32px; */
}

    /* .filter{
        margin-bottom: 16px;
    } */

    .filterName{
        cursor: pointer;
        font-weight: 400;
        font-size: 14.9343px;
        line-height: 25px;
        color: #41434C;
        opacity: 0.8;
        padding: 8px 12px 8px 15px;
        /* margin-bottom: 18px; */
        display: flex;
        background: #F5F5F5;
        border-radius: 17px;
        margin-right: 16px;
        width: 290px;
        display: flex;
        justify-content: space-between;
        text-transform: capitalize;
    }
</style>